var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block image",class:_vm.block.size ? ("image--" + (_vm.block.size)) : ''},[_c('img',{attrs:{"src":("/gfx/content/" + (_vm.block.value))}})])}
var staticRenderFns = []

export { render, staticRenderFns }